import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { getBattery } from '../Api'

export default generateApiAction({
  baseType: Types.BATTERIES.GET,
  api: getBattery,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/batteries/GetAction.js